import { CustomError } from '@/utilities/errors/CustomError';
import { ErrorType } from '@/utilities/errors/types';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { APIServiceType } from '../types';

interface LogAndThrowApiErrorOptions {
  error: unknown;
  logName: string;
  description: string;
  service: APIServiceType;
  customErrorMessage: string;
  context?: Record<string, unknown>;
}

export const logAndThrowApiError = ({
  error,
  logName,
  description,
  service,
  customErrorMessage,
  context = {},
}: LogAndThrowApiErrorOptions): never => {
  const errorMessage = error instanceof Error ? error.name : 'Unknown error';

  Logger.logRumError({
    name: logName,
    description,
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Error,
    service: 'client',
    stack: error instanceof Error ? error.stack : undefined,
    context: {
      error: errorMessage,
      ...context,
    },
  });

  throw new CustomError(customErrorMessage, {
    type: ErrorType.API,
    reason: errorMessage,
    service,
  });
};
